/**
 * 键盘性能宿主钩子：GCOME 进入设备时若非 USB3，提示 USB2 弹窗。
 * 在 DeviceStore.init 幂等注册；SDK checkConnect 内 fire-and-forget 调用。
 * 「不再显示」仅作用于进入设备提示；性能配置页点 16K 仍强制弹窗。
 */
import { createApp, type App } from 'vue'
import { setKeyboardPerfHostHooks, type KeyboardPerfHostHooks } from '@rapoo/device-sdk'
import i18n from '@/locales'
import Usb2With16kDialog from '@/components/performance/Usb2With16kDialog.vue'
import { dismissUsb2Tip, isUsb2TipDismissed } from '@/utils/usb2TipPreference'

function notifyUsb2With16kDriver(): Promise<void> {
  if (isUsb2TipDismissed()) return Promise.resolve()

  return new Promise((resolve) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let settled = false
    let app: App<Element> | null = null
    const finish = () => {
      if (settled) return
      settled = true
      app?.unmount()
      app = null
      container.remove()
      resolve()
    }

    app = createApp(Usb2With16kDialog, {
      allowDismiss: true,
      onConfirm: finish,
      onDismiss: () => {
        dismissUsb2Tip()
        finish()
      },
    })
    app.use(i18n)
    app.mount(container)
  })
}

const hooks: KeyboardPerfHostHooks = {
  notifyUsb2With16kDriver,
}

let registered = false

/** 幂等：DeviceStore.init 调用；已注册则跳过 */
export function ensureKeyboardPerfHostHooks(): void {
  if (registered) return
  setKeyboardPerfHostHooks(hooks)
  registered = true
}
